/**
 * 报表类型枚举
 */

export enum ReportFileTypeEnum {
    DAILY=1,
    WEEKLY=2,
    MONTHLY=3,
    PARCEL_DOWNLOAD=4,
    OTHER_CARRIER_BAG_TASK=5,
    PICKUP_APPOINTMENT=6,
    POD_REVIEW=7,
    ZIPCODE_EXPORT=8,
    DASHBOARD_EXPORT=9,
    VOUCHER_CLEANING=10,
    ACCOUNT_TRANSACTION_FLOW=11,
    ACCOUNT_BALANCE_SNAPSHOT=13,
    TRANSACTION_FLOW_RECORD=15,
    REALTIME_SETTLEMENT_ORDER_DETAIL=16,
    TMS_TASK=17,
    EXCEPTION_DOWNLOAD=18,
    CHANNEL_ONBOARDING_DOCUMENT=19,
    DELIVERY_DRIVER_EXPORT=20,
    ORDER_CLOSE_TOOL_DOWNLOAD=21,
    BAG_TAG_EXPORT=22,
    WAREHOUSE_LOCATION_EXPORT=23,
    DELIVERY_TASK_TRACKING_NUMBER_EXPORT=24,
    CLIENT_HUB_ZONE_IMPORT_TASK=25,
    PRICING_SCHEME_EXPORT=26,
    DELIVERY_CONFIRM_FEEDBACK=27,
    COOPERATION_WAREHOUSE_BLACKLIST_DOWNLOAD=28,
    PICKUP_PROGRESS=29,
    DSP_SUMMARY_EXPORT=30,
    MISSING_UNIT_PENDING=31,
    QC_PENALTY_UPLOAD_RESULT=32,
    PARCEL_SHIPPING_LABEL_PDF=33,
    PRICING_FAIL_DATA_DETAIL=34,
    PRE_BILL_REVISION_TASK_DETAIL=35,
    BILLING_PERIOD_SUMMARY=36,
    BILLING_PERIOD_RECEIVE_SUMMARY=37,
    REALTIME_INCOME_DAILY_SUM=38,
    REALTIME_INCOME_DAILY_RECEIVE_SUM=39,
    REVIEW_TASK_EXPORT=40,
    ROUTE_ORDER_POOL_EXPORT=41,
    UNDELIVERABLE_UPLOAD_DETAIL=42,
    // 与后端 ReportTypeEnum 逐值对应，改值必须两侧同步。
    // 本值原为 45，合并 main 后让位：45/46 已被 settlement-service 的
    // REALTIME_INVOICE_ORDER_DETAIL / DSP_BILL_LIST_EXPORT 占用（那两个由 settlement 侧
    // 以裸 Int 写入）。不同步的后果不是报错而是功能静默失效——后端
    // pickupDownloadReportTypes 白名单同时管列表过滤与下载鉴权，前端仍传 45 时
    // 筛选「揽收任务下载」查不到任何记录，不筛选时该类型的报表在列表里显示成「其他」。
    PICKUP_TASK=47,
    PARTNER_PENALTY_EXPORT=48,
    APPEAL_REVIEW_EXPORT=49,
    POP_REVIEW_EXPORT=50,
    DRIVER_ACTIVITY_RISK_LOG_EXPORT=51,
}

/**
 * 报表文件状态枚举
 */
export enum ReportFileStatusEnum {
    DOWNLOADING = 0,    // 下载中
    COMPLETED = 1,      // 已完成
    FAILED = 2          // 失败
}
